module.exports = __webpack_public_path__ + "static/1222788544-wide.8c449302.jpg";